// @flow

import qs from 'qs';
import Api from '../ApiBase';

const getListParams = () => qs.stringify({
  page: {
    limit: 100
  }
});

class EntryLevelsApi extends Api {
  fetch = async () => {
    const json = await this.request(`search_entry_levels?${getListParams()}`);
    const data = await this.deserialize(json);

    return { data };
  }
}

export default new EntryLevelsApi();
